/* 基准主题 */
let baseThemes = {
  primaryColor: '#5d9cec',
  bubbleColor: '#dbefff',
  fontSize: 'small',
  fontColor: 'medium',
};

/* 合并所有的themes */
let mergedThemes = {};

/* 合并所有的styles */
let mergedStyles = {};

// Queue
const replaceCssQueue = [];

// 获取字体颜色
function getFontColor(fontColorType = 'medium') {
  return fontColorType === 'light' ? '#666' : fontColorType === 'deep' ? '#000' : '#333';
}

// 获取字号
function getFontSize(fontSizeType = 'small') {
  const sFontSize = { lg: '16px', md: '14px', sm: '12px' };
  const mFontSize = { lg: '16px', md: '16px', sm: '14px' };
  const lFontSize = { lg: '16px', md: '16px', sm: '16px' };
  return fontSizeType === 'big' ? lFontSize : fontSizeType === 'medium' ? mFontSize : sFontSize;
}

// 替换字号
function changeFontSize(ofs, tfs, cssText) {
  if (!cssText || ofs === tfs) return cssText;
  return cssText.replace(new RegExp(`(font-size:\\s?)${ofs};?`, 'g'), `$1${tfs};`);
}

/**
 * 替换css
 * @param {string} cssText css text
 * @param {object} [settings] Options object
 * @param {object} [settings.styles]
 * @param {object} [settings.themes]
 * @param {function} [settings.transformCss]
 * @returns 
 */
function replaceCss(cssText, settings = {}) {
  if (!cssText) {
    return false;
  }

  const { themes, styles, transformCss } = settings;

  let newCssText = cssText;

  /* 合并最新的主题 */
  mergedThemes = { ...mergedThemes, ...themes || {} };

  /* 合并最新的样式 */
  mergedStyles = { ...mergedStyles, ...styles || {} };

  /* 将需要替换的样式推入堆栈 */
  replaceCssQueue.push(transformCss);

  // 匹配替换主题theme
  Object.keys(mergedThemes).forEach(theme => {
    // 如果前后主题没有改变，则无需处理
    if (baseThemes[theme] === mergedThemes[theme]) return;
    switch(theme) {
      case 'primaryColor':
        // 切换主题颜色
        newCssText = newCssText.replace(new RegExp(baseThemes.primaryColor, 'gm'), mergedThemes.primaryColor);
        break;
      case 'bubbleColor':
        // 切换气泡颜色
        newCssText = newCssText.replace(new RegExp(baseThemes.bubbleColor, 'gm'), mergedThemes.bubbleColor);
        break;
      case 'fontColor':
        const oldFontColor = getFontColor(baseThemes.fontColor);
        const fontColor = getFontColor(mergedThemes.fontColor);
        // 切换字体颜色
        newCssText = newCssText.replace(new RegExp(oldFontColor, 'gm'), fontColor);
        break;
      case 'fontFamily':
        styles['font-family'] = styles['font-family'] || mergedThemes.fontFamily;
        break;
      case 'fontSize':
        const oldFontSize = getFontSize(baseThemes.fontSize);
        const fontSize = getFontSize(mergedThemes.fontSize);
        // 切换字体大小
        newCssText = changeFontSize(oldFontSize.lg, fontSize.lg, newCssText);
        newCssText = changeFontSize(oldFontSize.md, fontSize.md, newCssText);
        newCssText = changeFontSize(oldFontSize.sm, fontSize.sm, newCssText);
        break;
      default:
        break;
    }
  });

  // 匹配替换样式css
  if (mergedStyles)
  Object.keys(mergedStyles).forEach(key => {
    // newCssText = newCssText.replaceAll('font-size: 12px', 'font-size: 14px');
    newCssText = newCssText.replace(new RegExp(`(${key}:\\s?)([^;\\n]*);?`, 'g'), `$1${mergedStyles[key]};`);
  });

  // 处理自定义转换css
  for(let i = 0; i < replaceCssQueue.length; i ++) {
    const fn = replaceCssQueue[i];
    if (typeof fn === 'function') {
      newCssText = fn(newCssText, settings) || newCssText;
    }
  }

  return newCssText;
}

export default replaceCss;
